<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>

    <template v-if="showForm && responseOrder !== null &&  responseOrder.products.length > 0">
      <form-order
          :productSelected="responseOrder.products"
          :coupon="coupon"
          :transportType="transport"
          :totalPrice="responseOrder.totalPrice"
          :subTotal="responseOrder.subTotal"
          :totalTax="responseOrder.totalTax"
          :totalOffer="responseOrder.totalOffer"
          :totalDifference="responseOrder.totalDifference"
          :totalPriceWithTransport="responseOrder.totalPriceWithTransport"
          :totalDiscount="responseOrder.totalDiscount"
          :users="users"
          :userIdProb="userId"
          :isAnonymous="isAnonymous"
      ></form-order>
    </template>

    <template v-else>
      <navbar>
        <template v-slot:navbarname>
          <b-button @click="cancelOrder" class="btn-round" variant="primary">back</b-button>
        </template>
      </navbar>


      <h2>Select User</h2>

      <b-overlay :show="isSubmitUsers" rounded="lg" opacity="0.6">
        <template #overlay>
          <div class="d-flex align-items-center">
            <b-spinner small type="grow" variant="secondary"></b-spinner>
            <b-spinner type="grow" variant="dark"></b-spinner>
            <b-spinner small type="grow" variant="secondary"></b-spinner>
            <!-- We add an SR only text for screen readers -->
            <span class="sr-only">Please wait...</span>
          </div>
        </template>

        <v-select
            class="mb-4"
            placeholder="Search users"
            :reduce="username => username.id"
            label="username"
            v-model="userId"
            @input="onSelectUser"
            @search="onSearchUsers"
            :options="users">
          <template #option="{ username, userSelect }">
            <h5 style="margin: 0">{{ username }}</h5>
            <em>{{ userSelect.email }}</em>
          </template>
        </v-select>

      </b-overlay>


      <b-form-checkbox v-model="isAnonymous">is anonymous?</b-form-checkbox>

      <template v-if="responseOrder !== null &&  responseOrder.products.length > 0">
        <b-row>
          <b-col cols="12" md="8">
            <b-card v-for="(item,index) in responseOrder.products" :key="index">
              <b-row>
                <b-col cols="12" md="8">
                  <b-media left-align vertical-align="center">
                    <template #aside>
                      <b-img :src="item.image"
                             style="object-fit: contain"
                             height="45"
                             width="80" alt="placeholder"></b-img>
                    </template>
                    <h5 class="mt-0 mb-1 font-weight-bold">{{ item.product }}</h5>
                    <p class="mt-0 mb-1">{{ item.amount_title }}</p>

                    <template v-if="item.is_package">
                      <br>
                      <h4>Packages</h4>
                      <b-form-checkbox-group
                          :options="item.package_items_front"
                          class="mb-3"
                          v-model="item.package_items"
                          required
                          value-field="title"
                          text-field="title"
                      ></b-form-checkbox-group>
                    </template>

                  </b-media>
                </b-col>
                <b-col cols="12" md="4">
                  <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      Preis
                      <span class="font-weight-bold">
                                        <template v-if="item.is_offer && item.show_admin === 'no'">
                                            <span class="mr-2"
                                                  style="text-decoration: line-through">{{
                                                item.price_front | numFormat('0.00')
                                              }} €</span>
                                            <span
                                                class="text-danger">{{
                                                item.price_sell_front | numFormat('0.00')
                                              }} €</span>
                                        </template>
                                        <template v-else>
                                            <span>{{ item.price_front | numFormat('0.00') }} €</span>
                                        </template>
                                    </span>
                    </b-list-group-item>

                  </b-list-group>


                  <b-overlay :show="isSubmit" rounded="lg" opacity="0.6">
                    <template #overlay>
                      <div class="d-flex align-items-center">
                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                        <b-spinner type="grow" variant="dark"></b-spinner>
                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                        <!-- We add an SR only text for screen readers -->
                        <span class="sr-only">Please wait...</span>
                      </div>
                    </template>

                    <b-form-spinbutton inline
                                       :value="item.count"
                                       min="1"
                                       @input="updateCountAmount(item.id,$event)"></b-form-spinbutton>
                  </b-overlay>


                </b-col>
              </b-row>

              <div class="text-left">
                <b-button
                    @click="deleteProduct(item.item_id)"
                    variant="danger">delete
                </b-button>
              </div>

            </b-card>
          </b-col>
          <!--End Items-->
          <b-col cols="12" md="4">
            <b-card>
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                                <span class="font-weight-bold">
                                    Zwischensumme
                                <br>
                                (ohne Rabatt):
                                </span>
                  <span>{{ responseOrder.subTotal | numFormat('0.00') }} €</span>
                </b-list-group-item>

                <b-list-group-item
                    v-if="coupon !== null"
                    class="d-flex justify-content-between align-items-center px-0 text-danger">
                                <span class="font-weight-bold">
                                   VIP-Kunde (-{{ coupon.coupon_amount }}% Rabatt) :
                                </span>
                  <span>{{ responseOrder.totalDiscount | numFormat('0.00') }} €</span>
                </b-list-group-item>

                <b-list-group-item
                    class="d-flex justify-content-between align-items-center px-0 text-danger">
                                <span class="font-weight-bold">
                                   Rabatt :
                                </span>
                  <span>{{ responseOrder.totalOffer | numFormat('0.00') }} €</span>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                                <span class="font-weight-bold">
                                    Zwischensumme
                                <br>
                                (mit Rabatt):
                                </span>
                  <span>{{ responseOrder.totalPrice | numFormat('0.00') }} €</span>
                </b-list-group-item>

                <b-list-group-item v-if="responseOrder.hasDifference"
                                   class="d-flex justify-content-between align-items-center px-0">
                                <span class="font-weight-bold">
                                    Differenz zum
                                <br>
                                Mindestbestellwert :
                                </span>
                  <span>{{ responseOrder.totalDifference | numFormat('0.00') }} €</span>
                </b-list-group-item>

              </b-list-group>
              <div class="border-top border-bottom">
                <b-form-group label="Liferung">
                  <b-form-radio-group
                      id="liferung"
                      @change="onSelectTransport"
                      v-model="transport"
                      :options="transportOptions"
                      name="radio-liferung"
                  ></b-form-radio-group>
                </b-form-group>
              </div>

              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                  <span class="font-weight-bold">inkl. 20% MwSt.</span>
                  <span>{{ responseOrder.totalTax | numFormat('0.00') }} €</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                  <span class="font-weight-bold">Gesamtsumme :</span>
                  <span>{{ responseOrder.totalPriceWithTransport | numFormat('0.00') }} €</span>
                </b-list-group-item>

              </b-list-group>


            </b-card>

            <template v-if="coupons.length > 0">
              <b-form-group label="select coupon (not required)">
                <v-select
                    placeholder="select coupon"
                    :reduce="coupon_code => coupon_code.coupon_id"
                    label="coupon_code"
                    v-model="couponId"
                    @input="calculationPrice"
                    :options="coupons"></v-select>
              </b-form-group>
            </template>


            <b-button
                :disabled="getCountSelectedPackages.length !== getProductPackages.length"
                block @click="formStep" variant="success">Weiter zur Kasse >
            </b-button>
            <template v-if="getCountSelectedPackages.length !== getProductPackages.length">
              <b-alert show variant="danger">Please select packages</b-alert>
            </template>
          </b-col>
          <!--END Prices-->
        </b-row>
      </template>
    </template>


  </div>
</template>

<script>
import Http from '../../Services/HttpService/HttpService'
import Notificaion from '../../Services/Notification/Nottification'
import {EventBus} from "../../Services/Eventbus/event-bus";
import Navbar from "../Partials/Navbar";
import 'vue-select/dist/vue-select.css';
import FormOrder from "./FormOrder";
import debounce from 'lodash/debounce'; import Vue from 'vue'


export default {
  name: "ProcessNewOrder",
  components: {FormOrder, Navbar},
  props: {
    productSelected: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      responseOrder: null,
      userId: 0,
      couponId: null,
      transport: null,
      transportOptions: [],
      users: [],
      coupons: [],
      coupon: null,
      showForm: false,
      isSubmit: false,
      isSubmitUsers: false,
      isAnonymous: false,
      isEmptySelectedPackages: false,
    }
  },
  methods: {
    deleteProduct(id) {
      if (this.responseOrder !== null && this.responseOrder.products.length > 0) {

        let findItem = this.responseOrder.products.find(item => item.item_id === id);
        if (findItem) {
          if (this.responseOrder.products.length <= 1) {
            this.cancelOrder();
          }

          this.responseOrder.products.splice(this.responseOrder.products.indexOf(findItem), 1);
          this.updateCart();

        }
      }


    },
    updateCountAmount(id, event) {
      let findItem = this.productSelected.find(item => item.product_id === id);
      if (findItem) {
        findItem.count = event;
        this.calculationPrice();
      }
    },
    formStep() {
      if (this.userId === 0) {
        Notificaion.error("Please Select User");
        return;
      }
      this.showForm = true;
    },
    cancelOrder() {
      EventBus.$emit('cancelOrder', 'yes');
    },
    deleteAllCart() {
      EventBus.$emit('deleteAllCart', 'yes');
    },
    updateCart() {
      EventBus.$emit('updateCart', this.responseOrder.products);
    },
    onSelectTransport() {
      this.calculationPrice();
    },
    onSelectUser() {
      this.getUsersCoupons();
    },
    calculationPrice() {
      if (this.productSelected.length > 0) {
        this.isSubmit = true;
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'order/factor/calculation', {
          items: this.productSelected,
          coupon_id: this.couponId,
          transport: this.transport
        })
            .then(response => {
              this.isSubmit = false;
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.responseOrder = response.data.data;
                this.coupon = response.data.data.coupon;


                this.getTransportOptions();
                //this.getUsers();

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    getTransportOptions() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/factor/transport/options', {
        price: this.responseOrder.totalPrice
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.transportOptions = response.data.data;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    },
    onSearchUsers(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: debounce((loading, search, vm) => {
      Http.get(Http.apiurlV2() + 'order/factor/users/'+escape(search))
          .then(response => {
            loading(false);
            if (response.data.status_code === Http.ok()) {
              vm.users = response.data.data;
            }
          })
          .catch(error => {
            this.isSubmitUsers = false;
            this.$Progress.finish();
          })
    }, 350),
    getUsers() {
      this.isSubmitUsers = true;
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'order/factor/users')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.isSubmitUsers = false;
              this.users = response.data.data;
            }
          })
          .catch(error => {
            this.isSubmitUsers = false;
            this.$Progress.finish();
          })

    },
    getUsersCoupons() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/factor/user/data', {
        type: 'coupon',
        userId: this.userId
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.coupons = response.data.data;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })

    }
  },
  computed: {
    getCountSelectedPackages() {
      if (this.responseOrder !== null && this.responseOrder.products.length > 0) {
        return this.responseOrder.products.filter(item => {
          return item.package_items.length;
        })
      } else {
        return 0;
      }
    },
    getProductPackages() {
      if (this.responseOrder !== null && this.responseOrder.products.length > 0) {
        return this.responseOrder.products.filter(item => {
          return item.is_package === true;
        })
      } else {
        return 0;
      }
    }
  },
  mounted() {
    this.calculationPrice();

    let myThis = this;
    EventBus.$on('processOrder', function (payload) {
      if (payload === 'yes') {
        myThis.showForm = false;
      }
    });
  }
}
</script>

<style scoped>

</style>